import './styles.scss'
import React from 'react'
import { COFFEEWEB_EXCHANGE } from 'Utils/Constants'

function CoffeeExchange() {
  return (
    <div className="coffee-exchange-container">
      <video controls className="exchange-image" autoPlay loop playsInline>
        <source src={COFFEEWEB_EXCHANGE.video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  )
}

export default CoffeeExchange
